if (import.meta.hot) {
  import.meta.hot.accept();
}

/**
 * Remove background utility classes from nested CE nodes
 * inside 2-column container elements.
 */
(function() {
  'use strict';

  function removeNestedBackgroundClasses() {
    const containerElements = document.querySelectorAll('.ce-type-altana-container-2cols');

    containerElements.forEach(containerElement => {
      const nestedCeElements = containerElement.querySelectorAll('.ce');

      nestedCeElements.forEach(nestedCeElement => {
        if (nestedCeElement === containerElement) {
          return;
        }

        nestedCeElement.classList.forEach(className => {
          if (className.startsWith('bg-')) {
            nestedCeElement.classList.remove(className);
          }
        });
      });
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', removeNestedBackgroundClasses);
    } else {
      removeNestedBackgroundClasses();
    }
  }

  init();
})();
